import React from 'react'
import { Modal } from 'react-bootstrap'
import { CrossIcon } from '../../../../Assets/svgIcons'
import "./InfluencerFeesModal.scss";

const InfluencerFeesModal = ({ show, handleClose }) => {
    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
            className="influencer_fees_modal"
        >
            <button onClick={handleClose} className='cross_btn' type='button'><CrossIcon /></button>
            <h2>Influencers fees</h2>
            <ul>
                <li>
                    <h3>David Smooth</h3>
                    <p>3%</p>
                </li>
                <li>
                    <h3>David Smooth</h3>
                    <p>2%</p>
                </li>
                <li>
                    <h3>David Smooth</h3>
                    <p>1.5%</p>
                </li>
                <li>
                    <h3>David Smooth</h3>
                    <p>3%</p>
                </li>
                <li>
                    <h3>David Smooth</h3>
                    <p>3%</p>
                </li>
                <li>
                    <h3>David Smooth</h3>
                    <p>3%</p>
                </li>
                <li>
                    <h3>David Smooth</h3>
                    <p>3%</p>
                </li>
                <li>
                    <h3>David Smooth</h3>
                    <p>3%</p>
                </li>
            </ul>
        </Modal>
    )
}

export default InfluencerFeesModal
